export const incomingRequests = {

  "title": "Matching intelligente",
  "subtitle": "Scopri i membri che vogliono visitare la tua regione",
  "requests": {
    "title": "Richieste",
    "count": "{{count}} richiesta(e)",
    "empty": {
      "noListingDescription": "Non hai ancora un annuncio. Pubblicane uno per ricevere richieste."
    },
    "loading": "Caricamento richieste...",
    "errors": {
      "notAuthenticated": "Devi effettuare l'accesso per visualizzare questa pagina.",
      "loadFailed": "Si è verificato un errore durante il caricamento delle richieste."
    },
    "defaultPropertyType": "Alloggio",
    "sortOptions": {
      "recent": "Più recente",
      "rating": "Il più votato",
      "distance": "Più vicino"
    }
  },
  "aiSection": {
    "title": "Suggerimenti intelligenti",
    "subtitle": "Scopri i membri che corrispondono ai tuoi criteri",
    "distance": "Distanza",
    "dates": "Date",
    "guests": "Viaggiatori",
    "matchScore": "Punteggio di compatibilità",
    "search": "Cerca",
    "startDiscussion": "Inizia discussione",
    "viewProfile": "Vedi profilo",
    "away": "di distanza"
  }
};
